<template>
  <figure class="prepeers-video-card">
    <PrePeersVideo
      :youtube-id="props.youtubeId"
      :title="props.videoTitle"
      aspect-ratio="video"
      @open="emit('open')" />
    <figcaption class="prepeers-video-card__caption">
      <strong class="prepeers-video-card__caption-title">{{ props.captionTitle }}</strong>
      <span class="prepeers-video-card__caption-text">{{ props.captionText }}</span>
    </figcaption>
  </figure>
</template>

<script lang="ts" setup>
import type { PrePeersVideoCardEmit, PrePeersVideoCardProps } from '~/types/PrePeersVideoCard'

import PrePeersVideo from '~/components/media/PrePeersVideo.vue'

const props: PrePeersVideoCardProps = defineProps({
  youtubeId: {
    type: String,
    required: true,
  },
  videoTitle: {
    type: String,
    required: true,
  },
  captionTitle: {
    type: String,
    required: true,
  },
  captionText: {
    type: String,
    required: true,
  },
})

const emit: PrePeersVideoCardEmit = defineEmits<{
  (event: 'open'): void
}>()
</script>

<style scoped>
.prepeers-video-card {
  margin: 0;
  overflow: hidden;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-xl);
  background: var(--bg-surface);
  box-shadow: var(--shadow-sm);
}

.prepeers-video-card :deep(.prepeers-video) {
  border-radius: 0;
}

.prepeers-video-card__caption {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid var(--border-subtle);
}

.prepeers-video-card__caption-title {
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--text-primary);
}

.prepeers-video-card__caption-text {
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
  color: var(--text-secondary);
}
</style>
